
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "components/Layout";
import Resume from "components/Resume";
function resume() {
    return (<Layout title="Resume - Sonahang Rai" image="https://www.sonahangrai.com/wp-content/uploads/2021/08/1606228885780.jpg" description="My career progress on a nutshell.">
      <Resume />
    </Layout>);
}
export default resume;

    async function __Next_Translate__getStaticProps__198fecf4c55__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/resume',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__198fecf4c55__ as getStaticProps }
  